module.exports = __webpack_public_path__ + "static/media/AU Research Roster - 2a - combined sans schedule info.4c0c0a06.csv";